import {Component} from 'react'
import {Link} from 'react-router-dom'
import Navbar from '../Navbar'
import './index.css'

class Home extends Component {
  render() {
    return (
      <div className="home-page-container">
        <Navbar />
        <hr className="line" />
        <div className="home-card">
          <div className="bio">
            <li className="hi">Hi.. I am Sumanth</li>
            <h1 className="job-role">I am a Mern Stack Developer</h1>
            <h2 className="short-bio">
              I am a Passionated Youngster, With Never give up attitude
            </h2>
            <div className="buttons">
              <button className="btn" type="button">
                <Link to="/about">About </Link>
              </button>
              <button className="btn" type="button">
                <Link to="/projects">Project </Link>
              </button>
            </div>
          </div>
          <img
            src="https://res.cloudinary.com/dv8xqk0gx/image/upload/v1706457752/bguviwomjo0ibjoy2fkm.jpg"
            alt="profile"
            className="image"
          />
        </div>
      </div>
    )
  }
}

export default Home
